import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import HospitalityProcessFlow from "./HospitalityProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  HOSPITALITY_DOMAIN_INTRO,
  HOSPITALITY_GROUPS,
  HOSPITALITY_USE_CASES_SEO,
  HOSPITALITY_DOMAIN_FAQS,
  HOSPITALITY_ITEM_LIST_JSONLD,
  HOSPITALITY_BREADCRUMB_JSONLD,
  HOSPITALITY_WEBPAGE_JSONLD,
  HOSPITALITY_FAQ_JSONLD,
} from "../../data/hospitalityUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<HospitalityProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = HOSPITALITY_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function HospitalityDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? HOSPITALITY_GROUPS : HOSPITALITY_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={HOSPITALITY_DOMAIN_INTRO}
        domainSlug="hospitality-domain"
        useCaseCount={HOSPITALITY_USE_CASES_SEO.length}
        groupCount={HOSPITALITY_GROUPS.length}
        itemListJsonLd={HOSPITALITY_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={HOSPITALITY_BREADCRUMB_JSONLD}
        faqJsonLd={HOSPITALITY_FAQ_JSONLD}
        webPageJsonLd={HOSPITALITY_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{HOSPITALITY_DOMAIN_INTRO.title}</h1>
          {HOSPITALITY_DOMAIN_INTRO.content ? <p>{HOSPITALITY_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={HOSPITALITY_USE_CASES_SEO} groups={HOSPITALITY_GROUPS} heading="Hospitality & Travel Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>

      <DomainHiddenSeoContent
        domainTitle={HOSPITALITY_DOMAIN_INTRO.title}
        domainFaqs={HOSPITALITY_DOMAIN_FAQS}
        useCases={HOSPITALITY_USE_CASES_SEO}
      />
    </div>
  );
}

